import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-11 w-full rounded-md border border-[#e4e1db] bg-white px-4 py-2 text-sm font-body text-ink shadow-none transition-[border-color,box-shadow] placeholder:text-[#a0a0a0] focus-visible:outline-none focus-visible:border-ink focus-visible:ring-[3px] focus-visible:ring-[rgba(14,14,14,0.06)] disabled:cursor-not-allowed disabled:opacity-50 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-ink",
        className
      )}
      ref={ref}
      {...props}
    />
  );
})
Input.displayName = "Input"

export { Input }
